<template>
  <div id="lookup">
    <form>
      <legend>
        {{$t('transaction_lookup')}}
      </legend>
      <div id="credentials">
        <div class="rows">
          <input id="username" class="textInput" type="text" :placeholder="$t('username')" v-model="username">
        </div>
        <div class="rows">
          <input id="password" class="textInput" type="password" :placeholder="$t('password')" :disabled="username.length < 3" v-model="password">
        </div>
      </div>

      <div class="rows">
        <input id="meterNumber" class="textInput" type="text" :placeholder="$t('meter_number') + ' (' + $t('optional') + ')'" v-model="meterNumber">
      </div>
      <div class="rows">
        <input id="plateNumber" class="textInput" type="text" :placeholder="$t('license_plate') + ' (' + $t('optional') + ')'" :value="plateNumber" @input="plateNumber = $event.target.value.toUpperCase()">
      </div>
      <div class="rows">
        <input id="ticketId" class="textInput" type="text" :placeholder="$t('ticket_identifier')" v-model="ticketNumber">
      </div>
      <div class="rows">
        <datepicker :placeholder="$t('transaction_date')" v-model="transactionDate" :language="this.$root.$children[0].dateLocale"/>
      </div>
      <div id="buttons-div" class="rows">
        <span>
          <form-button id="button-reset" @click.native="resetValues">{{$t('buttons.reset')}}</form-button>
          <form-button @click.native="searchTransactions" :disabled="!validated"> {{$t('buttons.search')}}</form-button>
        </span>
      </div>
    </form>

    <div id="reporting">
      <component :is="reportingComponent" v-bind="reportingProperties">{{reportingSlot}}</component>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Datepicker from 'vuejs-datepicker'
  import FormButton from './FormButton';
  import TransactionTable from './TransactionTable';
  import Notification from './Notification';
  import PulseLoader from 'vue-spinner/src/PulseLoader';

    export default {

      name: "TransactionLookup",
      components: {Notification, TransactionTable, axios, Datepicker, FormButton, PulseLoader},
      data() {
        return {
          username: '',
          password: '',
          meterNumber: '',
          plateNumber: '',
          ticketNumber: '',
          transactionDate: '',
          reportingComponent: '',
          reportingProperties: {},
          reportingSlot: '',
          pulsarApi: {
            url: 'asset_interface/asset_service.php',
            config: {
              auth: {
                username: 'webportal',
                password: '>),xj26+5=HAVaQy'
              },
              baseURL: 'https://pulsar.parkeonsmartcenter.com/'
            }
          }
        }
      },
      computed: {
        transactionDatestamp () {
          return this.transactionDate.getFullYear() + '-'
            + this.pad(this.transactionDate.getMonth()+1) + '-'
            + this.pad(this.transactionDate.getDate())
        },
        validated () {
          return Boolean(this.username
            && this.password
            && this.ticketNumber
            && this.transactionDate)
        }
      },
      methods: {
        pad (n) {
          return n<10 ? '0'+n : n
        },
        searchTransactions () {
          let clause = "username='" + this.username + "'"
            + " AND password='" + this.password + "'"
            + " AND transaction_id=" + this.ticketNumber
            + " AND sale_date='" + this.transactionDatestamp + "'"

          if(this.meterNumber) {
            clause += " AND machine_number=" + this.meterNumber
          }
          if(this.plateNumber) {
            clause += " AND plate='" + this.plateNumber + "'"
          }

          let body = {
            'service_code' : 4,
            'container': 'transactions',
            'clause': clause,
            'action': 'select',
            'data': ''
          }

          // Start loader
          window.scrollTo(0,document.body.scrollHeight);
          this.reportingComponent = PulseLoader
          this.reportingProperties = {
            color: '#8cb6c0'
          }

          axios.post(this.pulsarApi.url, body, this.pulsarApi.config)
            .then(response => {
              this.reportingComponent = TransactionTable
              this.reportingProperties = {"transactionData": response.data.data}
            })
            .catch(error => {
              this.reportingComponent = Notification
              this.reportingProperties = {'level':'error'}

              if(error.response === undefined) {
                this.reportingSlot = this.$t('response.400')
                return
              }

              switch (error.response.status) {
                case 403:
                  this.reportingSlot = this.$t('response.transaction.403')
                  break
                case 404:
                  this.reportingSlot = this.$t('response.transaction.404')
                  break
                default:
                  this.reportingSlot = this.$t('response.400')
                  break
              }
            });
        },
        resetValues () {
          this.username = ''
          this.password = ''
          this.meterNumber = ''
          this.plateNumber = ''
          this.ticketNumber = ''
          this.transactionDate = ''
          this.reportingComponent = ''
          this.reportingProperties = {}
          this.reportingSlot = ''
        }
      }
    }
</script>

<style scoped>
  form {
    width: 100%;
    font-size: 17px !important;
    color: black;
  }

  legend {
    font-size: 38px;
    color: #ba4c3e;
    font-weight: 600;
  }

  .rows {
    height: 50px;
    margin-top: 13px;
    width: 100%;
    box-sizing: border-box;
    display: block;
  }

  .rows * {
    height: 100%;
    line-height: 50px;
    display: inline-block;
    border: none;
    float: left;
  }

  #button-reset {
    color: #244148;
    background-color: transparent;
    border: 1px solid #244148;
  }

  #buttons-div {
    margin-top: 40px;
  }

  #buttons-div span {
    float: right;
  }

  #buttons-div button {
    margin-left: 15px;
    min-width: 150px;
  }

  #credentials {
    padding: 10px 0 20px 0;
  }

  #lookup {
    max-width: 580px;
  }

  #reporting {
    width: 100%;
    padding-top: 50px;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/TransactionLookup.vue